<template>
  <v-card flat>
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.SERVICE_LOCATION_TYPE')">
          <FormSelect
            v-model="form.serviceLocationTypeId"
            :options="serviceLocationTypes"
            :validateState="validateState('serviceLocationTypeId')"
            clearable
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.NAME')">
          <FormInput
            v-model="form.name"
            type="text"
            name="name"
            :i18n="{ placeholder: 'FORM_LABELS.NAME' }"
            :validateState="validateState('name')"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('FORM_LABELS.LOCATION')">
          <FormInput
            v-model="form.location"
            type="text"
            name="location"
            :i18n="{ placeholder: 'FORM_LABELS.LOCATION' }"
            :validateState="validateState('location')"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";
import { FETCH_SERVICE_LOCATION_TYPES } from "@/modules/service-locations/store/service-locations.module";
import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";

export default {
  mixins: [validationMixin, formBuilderMixin],
  components: {
    FormInput,
    FormSelect
  },
  props: {
    form: Object
  },
  data() {
    return {
      serviceLocationTypes: []
    };
  },
  validations() {
    return {
      form: {
        serviceLocationTypeId: { required },
        name: { required },
        location: {}
      }
    };
  },
  mounted() {
    this.loadServiceLocationTypes();
  },
  methods: {
    validateState(name) {
      const field = this.$v.form[name];
      if (!field) {
        return null;
      }

      const { $dirty, $error } = field;
      return $dirty ? !$error : null;
    },
    loadServiceLocationTypes() {
      this.$store.dispatch(FETCH_SERVICE_LOCATION_TYPES).then(response => {
        this.serviceLocationTypes = response.data || [];
      });
    }
  }
};
</script>
